import React, { useState } from 'react';

const YouTubePage = () => {
  const [activeTab, setActiveTab] = useState('featured');

  // Featured videos - you can update these with your actual video IDs
  const featuredVideos = [
    {
      id: 'OSapzIqJkzc', // This is from your Oct 8, 1989 page
      title: 'October 8, 1989 - Special Memory',
      description: 'A meaningful moment from October 8, 1989'
    }
    // Add more video IDs here as you create content
  ];

  return (
    <div className="page-container-wrapper max-width-default padding-default">
      <div className="page-header">
        <h1>
          <i className="fab fa-youtube"></i>
          Marco De Marco YouTube Channel
        </h1>
        <p>Watch videos, stories, and content directly here or visit my channel for more.</p>
      </div>

      <div className="page-content">
        <div className="section">
          <div className="youtube-content">
            <p className="welcome-text">
              Welcome to my YouTube channel! Here you can watch my videos directly
              or visit my channel for the complete collection of stories, memories,
              and experiences that are important to me and my family.
            </p>

            {/* Tab Navigation */}
            <div className="youtube-tabs">
              <button 
                className={`tab-button ${activeTab === 'featured' ? 'active' : ''}`}
                onClick={() => setActiveTab('featured')}
              >
                Featured Videos
              </button>
              <button 
                className={`tab-button ${activeTab === 'recent' ? 'active' : ''}`}
                onClick={() => setActiveTab('recent')}
              >
                Recent Uploads
              </button>
              <button 
                className={`tab-button ${activeTab === 'channel' ? 'active' : ''}`}
                onClick={() => setActiveTab('channel')}
              >
                Channel Info
              </button>
            </div>

            {/* Featured Videos Tab */}
            {activeTab === 'featured' && (
              <div className="tab-content">
                <h3>Featured Videos</h3>
                <div className="videos-grid">
                  {featuredVideos.map((video, index) => (
                    <div key={index} className="video-item">
                      <div className="video-wrapper">
                        <iframe
                          width="100%"
                          height="315"
                          src={`https://www.youtube.com/embed/${video.id}`}
                          title={video.title}
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                        ></iframe>
                      </div>
                      <div className="video-info">
                        <h4>{video.title}</h4>
                        <p>{video.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Recent Uploads Tab */}
            {activeTab === 'recent' && (
              <div className="tab-content">
                <h3>Recent Uploads</h3>
                <div className="playlist-embed">
                  <iframe
                    width="100%"
                    height="400"
                    src="https://www.youtube.com/embed/videoseries?list=UUMarcoDeMarco11"
                    title="Recent Uploads Playlist"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
                <p className="playlist-note">
                  This shows my most recent video uploads. New videos will automatically appear here.
                </p>
              </div>
            )}

            {/* Channel Info Tab */}
            {activeTab === 'channel' && (
              <div className="tab-content">
                {/* Channel Link */}
                <div className="channel-info">
                  <h3>Visit My Channel</h3>
                  <div className="channel-link-container">
                    <a 
                      href="https://www.youtube.com/@MarcoDeMarco11" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="youtube-channel-link"
                    >
                      <i className="fab fa-youtube"></i>
                      @MarcoDeMarco11
                    </a>
                  </div>
                </div>

                {/* Channel Description */}
                <div className="channel-description">
                  <h3>About the Channel</h3>
                  <p>
                    This YouTube channel is a place where I share personal stories,
                    family memories, and experiences that have shaped my life.
                    From family history to personal reflections, you'll find content
                    that celebrates heritage, family, and the moments that matter most.
                  </p>
                </div>

                {/* What to Expect */}
                <div className="content-preview">
                  <h3>What You'll Find</h3>
                  <ul>
                    <li>Family stories and memories</li>
                    <li>Personal reflections and experiences</li>
                    <li>Heritage and cultural content</li>
                    <li>Special moments and celebrations</li>
                    <li>Stories that connect past and present</li>
                  </ul>
                </div>

                {/* Call to Action */}
                <div className="subscribe-section">
                  <p>
                    <strong>Don't forget to subscribe and hit the notification bell</strong> to stay
                    updated with new videos and stories as they're shared!
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default YouTubePage;